import Cover from "./Cover";
import Description from "./Description";

export default {
  Cover,
  Description
};
